import { render, staticRenderFns } from "./TagIcon.vue?vue&type=template&id=164c8866"
import script from "./TagIcon.vue?vue&type=script&lang=ts"
export * from "./TagIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164c8866')) {
      api.createRecord('164c8866', component.options)
    } else {
      api.reload('164c8866', component.options)
    }
    module.hot.accept("./TagIcon.vue?vue&type=template&id=164c8866", function () {
      api.rerender('164c8866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/TagIcon.vue"
export default component.exports